"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVerificationStatus = void 0;
const getVerificationStatus = ({ raw, generated, fields, }) => {
    if (!raw) {
        // there was no raw document entry,
        // this means raw document was not uploaded.
        return 'Untested';
    }
    if (!generated) {
        // there was no generated document entry,
        // this mean textract or sanitize failed.
        return 'TextractFailed';
    }
    // find any field that failed.
    const failed = fields.find(({ result }) => !result || !result.verificationResult);
    if (!failed) {
        return 'Passed';
    }
    // when we edit generated records manually. we set artifactDocumentId to null.
    // this is how we know that the generated record was edited manually.
    const manualEdits = generated.artifactDocumentId === null;
    return manualEdits ? 'VerifiedFailure' : 'UnverifiedFailure';
};
exports.getVerificationStatus = getVerificationStatus;
//# sourceMappingURL=getVerificationStatus.js.map